import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	LegacyMacroRendererQueryBodyQuery,
	type LegacyMacroRendererQueryBodyQuery$data,
	type LegacyMacroRendererQueryBodyQuery$variables,
} from '@confluence/fabric-extension-queries/entry-points/LegacyMacroRendererQueryBodyQuery.graphql.ts';
import {
	LegacyMacroRendererQueryContentQuery,
	type LegacyMacroRendererQueryContentQuery$data,
	type LegacyMacroRendererQueryContentQuery$variables,
} from '@confluence/fabric-extension-queries/entry-points/LegacyMacroRendererQueryContentQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadMacrosSPA(): Promise<
	(
		| {
				data: LegacyMacroRendererQueryBodyQuery$data | null;
				errors?: ReadonlyArray<GraphQLErrorInterop>;
				hasErrors: boolean;
		  }
		| {
				data: LegacyMacroRendererQueryContentQuery$data | null;
				errors?: ReadonlyArray<GraphQLErrorInterop>;
				hasErrors: boolean;
		  }
	)[]
> {
	const macroParams: any[] = window['__LEGACY_MACRO_PARAMS__'] || [];
	window['__LEGACY_MACRO_PARAMS__'] = [];

	// eslint-disable-next-line check-preloaders/no-promise-all
	return Promise.all(
		macroParams.map(({ isMacroContentAndBody, ...rest }) => {
			return isMacroContentAndBody
				? query<
						LegacyMacroRendererQueryBodyQuery$data,
						LegacyMacroRendererQueryBodyQuery$variables
					>({
						query: LegacyMacroRendererQueryBodyQuery,
						variables: rest,
						context: { single: true },
					})
				: query<
						LegacyMacroRendererQueryContentQuery$data,
						LegacyMacroRendererQueryContentQuery$variables
					>({
						query: LegacyMacroRendererQueryContentQuery,
						variables: rest,
						context: { single: true },
					});
		}),
	);
}
